import expertsReducer, { expertsInitialState } from './experts';
import imageModalReducer, { imageModalInitialState } from './imageModal';
import menuModalReducer, { menuModalInitialState } from './menuModal';
import messagesReducer, { messagesInitialState } from './messages';
import metaReducer, { metaInitialState } from './meta';
import checkoutReducer, { checkoutInitialState } from './checkout';
import dialogsReducer, { dialogsInitialState } from './dialogs';
import environmentReducer, { environmentInitialState } from './environment';

const initialState = {
  experts: expertsInitialState,
  imageModal: imageModalInitialState,
  menuModal: menuModalInitialState,
  messages: messagesInitialState,
  meta: metaInitialState,
  checkout: checkoutInitialState,
  dialogs: dialogsInitialState,
  environment: environmentInitialState,
};

export default function combinedReducer(state = initialState, action) {
  return {
    experts: expertsReducer(state.experts, action),
    imageModal: imageModalReducer(state.imageModal, action),
    menuModal: menuModalReducer(state.menuModal, action),
    messages: messagesReducer(state.messages, action),
    meta: metaReducer(state.meta, action),
    checkout: checkoutReducer(state.checkout, action),
    dialogs: dialogsReducer(state.dialogs, action),
    environment: environmentReducer(state.environment, action),
  };
}
